// @flow
import * as React from "react";
import {css, StyleSheet} from "aphrodite";


const Name = () => (
    <div className={css(styles.name)}>Erik Henry Restificar</div>
);
const translateKeyFrames = {
    '0%': {
        opacity: 0,
    },
    '100%': {
       opacity: 1,
    },
};

const styles = StyleSheet.create({
    name: {
        fontSize: 18,
        marginTop: 5,
        textTransform: "uppercase",
        animationName: [translateKeyFrames],
        animationDuration: `3000ms`,
        animationDelay: `4000ms`,
        animationIterationCount: 1,
        animationFillMode: "both",
        transformOrigin: "center",
        perspectiveOrigin: "center",
    },
});

export default Name;
